import { FunctionComponent } from 'react'
import classes from './index.module.css'
import Icon from '@mdi/react'
import { mdiArrowRight } from '@mdi/js'
import { Button } from '@material-ui/core'
import CurrentStatus from './components/CurrentStatus'
import Filters from './components/Filters'
import Orders from './components/Orders'
import ContextProvider from './ContextProvider'
import { Link } from 'react-router-dom'

const OperatorAssignment: FunctionComponent = () => {
  return (
    <ContextProvider>
      <div className={classes.container}>
        <div className={classes.rowBetween}>
          <div className={classes.title}>
            <Link className={classes.backLink} to='/warehouse-admin-orders'>
              <Icon path={mdiArrowRight} size={1} />
            </Link>
            <h1>اختصاص اتوماتیک سفارش به اپراتور‌ها</h1>
          </div>
          <div className='history-button'>
            <Button variant='outlined' color='secondary' size='large' disabled>
              تاریخچه تغییر تنظیمات
            </Button>
          </div>
        </div>
        <CurrentStatus />

        <div className={classes.cards}>
          <Filters />
          <Orders />
        </div>
      </div>
    </ContextProvider>
  )
}

export default OperatorAssignment
